import React from 'react';
import { graphql } from 'gatsby';
import { useSetState } from 'react-use';

import BlockContent from 'organisms/BlockContent';
import Button from 'molecules/Button';
import Container from 'molecules/Container';
import Input from 'molecules/Input';
import InputNumber from 'molecules/InputNumber';
import Image from 'molecules/Image';
import MaskedInput from 'molecules/MaskedInput';
import Footer from 'organisms/FooterClone';
import Form, { WrappedForm } from 'organisms/Form';
import Header from 'organisms/HeaderClone';
import Radio from 'molecules/Radio';

import giftImg from 'static/images/gift-certificates.png';
import './StoreCredit.scss';


export const query = graphql`
  query ( $id: String  ) {
    page: sanityPage( id: { eq: $id } ) {
      productID
      seo {
        meta_description
        seo_title
      }
      slug {
        current
      }
      title
      pageTemplate: _rawPageTemplate(resolveReferences: {maxDepth: 3})
    }
  }
`;
export default function( p ) {

  const { page } = p.data;
  const content = page.pageTemplate.StoreCredit;


  /* ------ = State. = --------------------------------------------------------------------- */
  const [ s, setState ] = useSetState( {
    amount: content.amount || null,
    isProcessing: false,
  } );

  /* ------ = Functions. = --------------------------------------------------------------------- */


  /**
   * Handle input change.
   */
  const handleInputChange = value => {

    if( typeof value !== 'number' ) {
      return;
    }

    setState( { amount: value } );

  }

  /**
   * Handle submit.
   */
  const handleSubmit = e => {

    setState( {
      isProcessing: true,
    } );

    window.location.href = `https://www.dartdrones.com/cart?add-to-cart=${page.productID}&nyp=${s.amount}`;

  }



  /* ------ = Output. = --------------------------------------------------------------------- */

  return(

    <div className="Credit">
      <Header />
        <main>

          <Container className="Credit__body">

            <h1 className="Credit__hding h-xl">{ content.heading }</h1>
            <p className="Credit__subhding h-thin">{ content.subHeading }</p>

            <div className="row">

              <div className="Credit__content col-md-4 p-md">
                <BlockContent blocks={ content.sideContent } />
              </div>

              <div className="col-md-4">

                <div
                className="Credit__form"
                >

                  { !! content.amount

                    ?
                      <InputNumber
                      prefix="$"
                      formatter={ value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      value={ s.amount }
                      defaultValue={ content.amount }
                      disabled={ true }
                      onChange={ handleInputChange }
                      />

                    :
                      <>

                        <h2 className="Credit__form-hding1 h-thin">
                          Enter Your Credit Amount
                        </h2>

                        <InputNumber
                        prefix="$"
                        formatter={ value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        value={ s.amount }
                        onChange={ handleInputChange }
                        />


                        { !! content.suggested && !! content.suggested.length &&

                          <>
                            <h3 className="Credit__form-hding2">Or select a suggested amount below</h3>

                            <Radio.Group
                            onChange={ e => setState( { amount: e.target.value } ) }
                            >

                              { content.suggested.map( amt => (
                                  <Radio value={ amt }>${ amt }</Radio>
                              ) ) }

                            </Radio.Group>

                          </>

                        }
                      </>
                  }


                  <Button
                  className="Credit__form-submit"
                  size="lg"
                  disabled={ ! s.amount }
                  isBusy={ s.isProcessing }
                  onClick={ handleSubmit }
                  >
                    Purchase Gift Certificate
                  </Button>


                </div>

              </div>

              <div className="Credit__img col-md-4">
                <Image
                src={ giftImg }
                />
              </div>
            </div>

          </Container>

        </main>
      <Footer />
    </div>

  );


}